import type { TFunction } from 'i18next';

/**
 * Simplified label for a document attachment's content type — "pdf" instead of
 * "application/pdf", "image" instead of "image/png". Unknown types fall back to a generic
 * "file"; undefined stays undefined so callers can drop the segment from metadata lines.
 */
export const documentTypeLabel = (contentType: string | undefined, t: TFunction<'records'>): string | undefined => {
  if (!contentType) return undefined;
  if (contentType.startsWith('application/pdf')) return t('documentTypePdf');
  if (contentType.startsWith('image/')) return t('documentTypeImage');
  if (contentType.startsWith('text/')) return t('documentTypeText');
  return t('documentTypeFile');
};
